import Schema from './Schema'
import FieldNumber from '../fields/FieldNumber'
export default class SchemaNumber extends Schema {
  constructor(label, key, items, options, on) {
    super(options)
    FieldNumber.call(this, label, key, items, options, on)
  }
}



// WEBPACK FOOTER //
// ./packages/helper/schema/SchemaNumber.js